import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../../components/common/faq";

const faqs = [
  {
    question: "What types of automotive apps do you develop?",
    answer: `<p>We specialize in a range of automotive applications, including vehicle tracking systems, fleet management solutions, car maintenance apps, navigation tools, and customer engagement platforms. Our focus is on creating apps that enhance the driving experience and optimize operations for automotive businesses.</p>`,
  },
  {
    question: "How do you ensure the security of automotive applications?",
    answer: ` <p>We prioritize security by implementing industry-standard encryption, secure APIs, and regular security audits throughout the development process. Our team follows best practices to safeguard user data and protect against cyber threats, ensuring a safe experience for your users.</p>`,
  },
  {
    question: "What technologies do you use for automotive app development?",
    answer: `<p>We leverage the latest technologies such as React Native, Flutter, and native Android/iOS development tools. Our team also incorporates IoT integrations and cloud services to enhance app functionality, providing seamless connectivity between vehicles and applications.</p>`,
  },
  {
    question: "How long does it take to develop an automotive app?",
    answer: `<p>The development timeline varies based on the app's complexity and features. Typically, our projects range from 3 to 6 months. We provide a detailed timeline during the initial consultation, ensuring transparency and alignment with your goals.</p>`,
  },
  {
    question: "Can you integrate third-party services into automotive apps?",
    answer: ` <p>Yes, we can integrate a variety of third-party services, including payment gateways, mapping services, and vehicle diagnostic tools. Our team ensures that these integrations work seamlessly, enhancing the overall functionality and user experience of your app.</p>`,
  },
  {
    question: "What post-launch support do you offer for automotive apps?",
    answer: ` <p>We provide comprehensive post-launch support, including bug fixes, performance monitoring, and regular updates to keep your app running smoothly. Our maintenance packages ensure your app remains up-to-date with the latest features and security measures.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#fff" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Automotive App Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
